import Icon from '../components/Icon.vue'

Icon.register({
  water: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M562.1 383.9c8.1 0.9 13.9 8.3 13.8 16.3v31.6c0 9.1-7.6 16.8-16.7 16-28.2-2.5-55.8-11.6-79.1-25.8-55 34.1-135.5 34.6-192 0-55 34.1-135.5 34.6-192 0-23.3 14.5-50.6 23.4-79.4 25.9-9.1 0.8-16.7-6.9-16.7-16v-32.2c0-7.9 5.7-14.9 13.6-15.7 21.7-2.3 42.2-10.2 57.7-22.4 13.8-10.9 33.6-13.2 47.1-2 38.3 31.7 107.2 31.8 145.2 1.7 13.7-10.9 33.2-13 46.7-1.8 38.5 31.9 107.8 31.9 145.7 1.5 14-11.3 34.1-11.1 48.2 0 15.8 12.4 36.4 20.5 57.9 22.9zM562.1 239.9c8.1 0.9 13.9 8.3 13.8 16.3v31.6c0 9.1-7.6 16.8-16.7 16-28.2-2.5-55.8-11.6-79.1-25.8-55 34.1-135.5 34.6-192 0-55 34.1-135.5 34.6-192 0-23.3 14.5-50.6 23.4-79.4 25.9-9.1 0.8-16.7-6.9-16.7-16v-32.2c0-7.9 5.7-14.9 13.6-15.7 21.7-2.3 42.2-10.2 57.7-22.4 13.8-10.9 33.6-13.2 47.1-2 38.3 31.7 107.2 31.8 145.2 1.7 13.7-10.9 33.2-13 46.7-1.8 38.5 31.9 107.8 31.9 145.7 1.5 14-11.3 34.1-11.1 48.2 0 15.8 12.4 36.4 20.5 57.9 22.9zM562.1 95.9c8.1 0.9 13.9 8.3 13.8 16.3v31.6c0 9.1-7.6 16.8-16.7 16-28.2-2.5-55.8-11.6-79.1-25.8-55 34.1-135.5 34.6-192 0-55 34.1-135.5 34.6-192 0-23.3 14.5-50.6 23.4-79.4 25.9-9.1 0.8-16.7-6.9-16.7-16v-32.2c0-7.9 5.7-14.9 13.6-15.7 21.7-2.3 42.2-10.2 57.7-22.4 13.8-10.9 33.6-13.2 47.1-2 38.3 31.7 107.2 31.8 145.2 1.7 13.7-10.9 33.2-13 46.7-1.8 38.5 31.9 107.8 31.9 145.7 1.5 14-11.3 34.1-11.1 48.2 0 15.8 12.4 36.4 20.4 57.9 22.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/water.js
// module id = 2104
// module chunks = 0